function webpushRequest(userId) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.addEventListener('load', () => {
    if (typeof window.webpush === 'undefined') {
      return;
    }
    const api = window.webpush.init();
    const getCookieValue = cookieName => document.cookie
      .split(' ')
      .filter(cookie => cookie.startsWith(`${cookieName}=`))
      .map(cookie => cookie.split('='))
      .map(([_key, details]) => details)
      .map(details => details.split(';'))
      .map(([value]) => value)
      .shift();
    const trackingId = getCookieValue('gptrackCookie');

    if (typeof api === 'undefined' || typeof trackingId === 'undefined') {
      return;
    }
    const trackingInfo = {
      trackingId,
      userId: userId || null
    };

    api.requestPermission(trackingInfo.trackingId, trackingInfo.userId);
  });

  /* eslint-disable-next-line no-process-env, unicorn/prevent-abbreviations */
  script.src = `${process.env.WEBPUSH_URL}/webpush.js`;
  // eslint-disable-next-line unicorn/prefer-node-append
  document.head.appendChild(script);
}

export default webpushRequest;
